import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from 'src/utils';

export const getReports = () => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(getReportsRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/reports',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getReportsSuccess(res.data));
      })
      .catch(err => {
        dispatch(getReportsFailure(err));
      });
  };
};

export const getReportRequests = (entityId, searchValues) => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(getReportRequestsRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/reports/requests',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getReportRequestsSuccess(res.data));
      })
      .catch(err => {
        dispatch(getReportRequestsFailure(err));
      });
  };
};

export const createReportRequest = reportRequest => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/reports/requests',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: reportRequest
    })
      .then(res => {
        dispatch(createReportRequestSuccess(res.data));
      })
      .catch(err => {
        dispatch(createReportRequestFailure(err));
      });
  };
};

export const deleteReportRequest = reportRequestId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/reports/requests/' + reportRequestId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(deleteReportRequestSuccess(res.data));
        dispatch(getReportRequests());
      })
      .catch(err => {
        dispatch(deleteReportRequestFailure(err));
      });
  };
};

// This has useful info on downloading files using axios
// https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios
//
export const exportReport = reportHandle => {
  return dispatch => {
    axios({
      url: '/reportDownloadService?reportHandle=' + reportHandle,
      method: 'GET',
      responseType: 'blob' // important
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', reportHandle);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        dispatch(clearReportsError);
      })
      .catch(err => {
        dispatch(downloadReportFailure(err));
      });
  };
};

export const clearReportsError = () => {
  return {
    type: Constants.REPORTS_CLEAR_ERROR
  };
};

const getReportsRequest = () => {
  return {
    type: Constants.REPORTS_GET_REQUEST
  };
};

const getReportsSuccess = data => {
  return {
    type: Constants.REPORTS_GET_SUCCESS,
    payload: data
  };
};

const getReportsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.REPORTS_GET_FAILURE,
    payload
  };
};

const downloadReportFailure = err => {
  const payload = 'Unable to find the requested report on the server.';
  return {
    type: Constants.REPORTS_DOWNLOAD_FAILURE,
    payload
  };
};

const getReportRequestsRequest = () => {
  return {
    type: Constants.REPORTS_GETREQ_REQUEST
  };
};

const createReportRequestSuccess = data => {
  return {
    type: Constants.REPORTS_CREATEREQ_SUCCESS,
    payload: data
  };
};

const createReportRequestFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.REPORTS_CREATEREQ_FAILURE,
    payload
  };
};

const getReportRequestsSuccess = data => {
  return {
    type: Constants.REPORTS_GETREQ_SUCCESS,
    payload: data
  };
};

const getReportRequestsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.REPORTS_GETREQ_FAILURE,
    payload
  };
};

const deleteReportRequestSuccess = data => {
  return {
    type: Constants.REPORTS_DELETE_SUCCESS,
    payload: data
  };
};

const deleteReportRequestFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.REPORTS_DELETE_FAILURE,
    payload
  };
};
